module.exports = __webpack_public_path__ + "static/media/PetInTimeFrame3.d2b45e36.png";